// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4eTg3","content":"styles_content__17iC0"};